export enum RoleIds {
  host = 3,
  player = 0,
  manager = 2,
  'manager host' = 7,
  'podcast host' = 8,
}

type RoleIdKeys = keyof typeof RoleIds;
export const ROLE_ID_KEYS = new Map<number, RoleIdKeys>(
  Object.entries(RoleIds).map(([key, value]: [RoleIdKeys, RoleIds]) => [value, key])
);
